import router from './router'
import store from './store'
import NProgress from 'nprogress' // Progress 进度条
import 'nprogress/nprogress.css'// Progress 进度条样式
import { Message } from 'element-ui' //使用element-ui的message组件
import { getToken } from '@/utils/auth' // 验权 获取里面getToken方法

const whiteList = ['/login'] // 不重定向白名单
//每次路由转发前执行(进入到哪个路由去,从哪个路由离开,路由的控制参数-常用的有next(true)和next(false))
router.beforeEach((to, from, next) => {
  NProgress.start()
  //如果cookie中有值,进入
  if (getToken()) {
    //如果准备去的地址是/login,就跳到首页
    if (to.path === '/login') {
      next({ path: '/' })
      NProgress.done() // 如果当前页面是dashboard不会触发afterEach钩子，所以手动处理
    } else {
      //如果没有获取到用户角色
      if (store.getters.roles.length === 0) {
        //获取用户的信息,包括menus和username
        store.dispatch('GetInfo').then(res => { // 拉取用户信息,调用action里面的方法
          //用户所拥有的菜单
          let menus=res.data.menus;
          let username=res.data.username;
          //得到可访问的路由列表
          store.dispatch('GenerateRoutes', { menus,username }).then(() => { // 生成可访问的路由表
            router.addRoutes(store.getters.addRouters); // 动态添加可访问路由表
            next({ ...to, replace: true })
          })
        }).catch((err) => {
          store.dispatch('FedLogOut').then(() => {
            Message.error(err || 'Verification failed, please login again')
            next({ path: '/' })
          })
        })
      } else {
        next()
      }
    }
  } else {
    //是否在白名单列表中
    if (whiteList.indexOf(to.path) !== -1) {
      next()
    } else {
      next('/login')
      NProgress.done()
    }
  }
})

//如果跳转后,结束进度条
router.afterEach(() => {
  NProgress.done() // 结束Progress
})



// WEBPACK FOOTER //
// ./src/permission.js